module.exports = __webpack_public_path__ + "img/pointer.bff64e5a.png";